// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 600px) {
    .banner-text {
        font-size: 20px !important;
        width: auto;
    }

    .ad-head-text {
        margin-left: 0px;
    }

    header {
        padding: 10px;
    }

    .container {
        padding: 50px 20px;
    }

    .circle {
        display: none;
    }

    .portfolio-container p,
    .solution-container p,
    .ad-head-text p,
    .review-container p {
        font-size: 25px;
    }

    .portfolio-container span,
    .solution-container span,
    .solution-grid p,
    .ad-head-text span,
    .campaign-right-grid span,
    .review-container span {
        font-size: 14px;
    }

    .banner-subtext {
        font-size: 14px !important;
    }

    .solution {
        padding: 50px 20px;
    }

    .ads-container {
        flex-direction: column;
        gap: 20px;
        padding: 20px 30px;
    }

    .banner-bottom-text span {
        font-size: 25px;
    }

    .carousel {
        margin: 0px;
    }

    .ads-responsive>div>img {
        width: 100%;
    }

    .campaign-responsive {
        flex-direction: column;
    }

    .campaign-responsive>div:first-child img {
        width: 100%;
    }

    .campaign-responsive>div:nth-child(2) {
        display: none;
    }

    .ads-container>div>img {
        width: 100%;
    }

    .carousel .testimonial p {
        font-size: 12px !important;
    }

    .carousel .overview .details,
    .carousel .overview b {
        font-size: 14px;
    }

    .item>.row>div {
        margin: 0px;
    }

    .carousel-indicators {
        bottom: -60px !important;
    }

    .bannerImg {
        display: none;
    }

    .footer>div:first-child {
        background-size: auto;
        flex-direction: column;
    }

    .footer>.solution>p {
        font-size: 14px;
        line-height: normal;
        width: 95%;
    }

    .footer button {
        width: auto;
        font-size: 12px !important;
    }

    .supportalign p {
        width: auto !important;
        position: static;
        margin: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {

    /* Your styles for tablets here */
    .bannerImg {
        display: none;
    }

    .box-ad-style {
        gap: 15px !important;
    }

    .campaign-responsive>div:nth-child(2),
    .campaign-responsive>div:nth-child(3) {
        margin-left: 5rem;
    }

    .ads-container {
        /* flex-direction: column; */
        /* gap: 30px; */
    }

    .ad-head-text {
        /* margin-left: 0px; */
    }

    .container {
        /* width: 800px !important; */
    }

    .ads-responsive>div:first-child img {
        width: 100%;
    }

    .campaign-responsive>div:first-child img {
        width: 100%;
    }

    .footer>div:first-child {
        background-size: 100%;
    }

    .footer>.solution>p {
        font-size: 25px;
        line-height: 50px;
    }

    .footer>.solution {
        padding: 15px;
    }

    .solution {
        padding: 30px 20px;
    }

    .ads-container {
        padding: 30px 50px;
    }

    .ads-container>div:first-child img {
        /* display: none; */
    }

    /* .campaign-responsive>div:first-child img {
        display: none;
    } */

    .item>.row>div {
        height: 430px;
    }

    .testimonial+div {
        position: absolute;
        bottom: 35px;
    }

    .supportalign p:nth-child(1) {
        left: 15%;
    }

    .supportalign p:nth-child(2) {
        left: 55%;
    }

    .supportalign p:nth-child(3) {
        left: -10px;
    }

    .supportalign p:nth-child(4) {
        width: 175px;
        left: 77%;
    }

    .supportalign p:nth-child(5) {
        width: 180px;
        left: -2%;
    }

    .supportalign p:nth-child(6) {
        width: 165px;
        left: 77%;
    }

    .supportalign p:nth-child(7) {
        left: 20%;
    }

    .supportalign p:nth-child(8) {
        left: 55%;
    }

    .supportalign>p {
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/mediaquery.css"],"names":[],"mappings":"AAAA;IACI;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;;QAII,eAAe;IACnB;;IAEA;;;;;;QAMI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ;;AAEA;;IAEI,iCAAiC;IACjC;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;OAEG;;IAEH;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@media only screen and (max-width: 600px) {\n    .banner-text {\n        font-size: 20px !important;\n        width: auto;\n    }\n\n    .ad-head-text {\n        margin-left: 0px;\n    }\n\n    header {\n        padding: 10px;\n    }\n\n    .container {\n        padding: 50px 20px;\n    }\n\n    .circle {\n        display: none;\n    }\n\n    .portfolio-container p,\n    .solution-container p,\n    .ad-head-text p,\n    .review-container p {\n        font-size: 25px;\n    }\n\n    .portfolio-container span,\n    .solution-container span,\n    .solution-grid p,\n    .ad-head-text span,\n    .campaign-right-grid span,\n    .review-container span {\n        font-size: 14px;\n    }\n\n    .banner-subtext {\n        font-size: 14px !important;\n    }\n\n    .solution {\n        padding: 50px 20px;\n    }\n\n    .ads-container {\n        flex-direction: column;\n        gap: 20px;\n        padding: 20px 30px;\n    }\n\n    .banner-bottom-text span {\n        font-size: 25px;\n    }\n\n    .carousel {\n        margin: 0px;\n    }\n\n    .ads-responsive>div>img {\n        width: 100%;\n    }\n\n    .campaign-responsive {\n        flex-direction: column;\n    }\n\n    .campaign-responsive>div:first-child img {\n        width: 100%;\n    }\n\n    .campaign-responsive>div:nth-child(2) {\n        display: none;\n    }\n\n    .ads-container>div>img {\n        width: 100%;\n    }\n\n    .carousel .testimonial p {\n        font-size: 12px !important;\n    }\n\n    .carousel .overview .details,\n    .carousel .overview b {\n        font-size: 14px;\n    }\n\n    .item>.row>div {\n        margin: 0px;\n    }\n\n    .carousel-indicators {\n        bottom: -60px !important;\n    }\n\n    .bannerImg {\n        display: none;\n    }\n\n    .footer>div:first-child {\n        background-size: auto;\n        flex-direction: column;\n    }\n\n    .footer>.solution>p {\n        font-size: 14px;\n        line-height: normal;\n        width: 95%;\n    }\n\n    .footer button {\n        width: auto;\n        font-size: 12px !important;\n    }\n\n    .supportalign p {\n        width: auto !important;\n        position: static;\n        margin: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n\n    /* Your styles for tablets here */\n    .bannerImg {\n        display: none;\n    }\n\n    .box-ad-style {\n        gap: 15px !important;\n    }\n\n    .campaign-responsive>div:nth-child(2),\n    .campaign-responsive>div:nth-child(3) {\n        margin-left: 5rem;\n    }\n\n    .ads-container {\n        /* flex-direction: column; */\n        /* gap: 30px; */\n    }\n\n    .ad-head-text {\n        /* margin-left: 0px; */\n    }\n\n    .container {\n        /* width: 800px !important; */\n    }\n\n    .ads-responsive>div:first-child img {\n        width: 100%;\n    }\n\n    .campaign-responsive>div:first-child img {\n        width: 100%;\n    }\n\n    .footer>div:first-child {\n        background-size: 100%;\n    }\n\n    .footer>.solution>p {\n        font-size: 25px;\n        line-height: 50px;\n    }\n\n    .footer>.solution {\n        padding: 15px;\n    }\n\n    .solution {\n        padding: 30px 20px;\n    }\n\n    .ads-container {\n        padding: 30px 50px;\n    }\n\n    .ads-container>div:first-child img {\n        /* display: none; */\n    }\n\n    /* .campaign-responsive>div:first-child img {\n        display: none;\n    } */\n\n    .item>.row>div {\n        height: 430px;\n    }\n\n    .testimonial+div {\n        position: absolute;\n        bottom: 35px;\n    }\n\n    .supportalign p:nth-child(1) {\n        left: 15%;\n    }\n\n    .supportalign p:nth-child(2) {\n        left: 55%;\n    }\n\n    .supportalign p:nth-child(3) {\n        left: -10px;\n    }\n\n    .supportalign p:nth-child(4) {\n        width: 175px;\n        left: 77%;\n    }\n\n    .supportalign p:nth-child(5) {\n        width: 180px;\n        left: -2%;\n    }\n\n    .supportalign p:nth-child(6) {\n        width: 165px;\n        left: 77%;\n    }\n\n    .supportalign p:nth-child(7) {\n        left: 20%;\n    }\n\n    .supportalign p:nth-child(8) {\n        left: 55%;\n    }\n\n    .supportalign>p {\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
